module.exports = __webpack_public_path__ + "img/motiplate-logo-round.932996f1.png";